import { openModal } from '../common/utils';
import { Resolutions } from '../common/const';

/**
 * @modal
 */
export const initModals = () => {
    // Open modal
    function onModalLinkClick(e) {
        e.preventDefault();
        const src = e.target.getAttribute(`data-src`);
        openModal(src, {
            afterLoadCb: (instance, el) => {
                el.$content.addClass(`animation`);
                if (src.indexOf(`compare`) !== -1) {
                    el.$content.addClass(`modal modal--compare`);
                    el.$content.append(`<a class="modal__close-link link link--secondary f-button-link mob-only" data-fancybox-close=""><span>Назад</span></a>`)
                }
            },
            beforeClose: (instance, el) => {
                el.$content.removeClass(`animation`);
            },
            afterClose: (instance, el) => {
                if (src.indexOf(`compare`) !== -1) {
                    el.$content.removeClass(`modal modal--compare`);
                }
            }
        });
    }

    // Events listeners
    document.documentElement.addEventListener(`click`, (e) => {
        let target = e.target;

        if (target === target.closest(`[data-fancybox]`)) {
            const isCompare = target.getAttribute(`data-src`).indexOf(`compare`) !== -1;
            if (!(isCompare && Resolutions.IS_DP())) {
                onModalLinkClick(e);
            } else {
                e.preventDefault();
            }
        }
    });
};

